import { gql } from "@apollo/client";

/*
 * NOTE: Temporary implementation (kept for reference).
 * This was added to compute tier from Redshift purchase totals.
 * Client requested using existing LoyaltyResult data instead.
 */
// export const GET_PURCHASE_TOTALS = gql`
//   query GetPurchaseTotals {
//     me {
//       purchaseTotals {
//         ytdPurchasesCents
//         previousYearPurchasesCents
//       }
//     }
//   }
// `;

export const GET_LOYALTY_TIER = gql`
  query GetLoyaltyTier {
    me {
      loyaltyTier
    }
  }
`;

